import { useState, type ReactNode, type CSSProperties, Children } from 'react';

interface TabsProps {
  tabs: Array<{ id: string; label: string }>;
  defaultTab?: string;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

export function TabsView({ tabs, defaultTab, className, style, children }: TabsProps) {
  const [activeTab, setActiveTab] = useState(defaultTab ?? tabs[0]?.id ?? '');
  const childArray = Children.toArray(children);
  const activeIndex = tabs.findIndex((t) => t.id === activeTab);

  return (
    <div className={`flex flex-col gap-0 h-full${className ? ` ${className}` : ''}`} style={style}>
      <div className="flex border-b border-zinc-200 dark:border-zinc-700" role="tablist">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            role="tab"
            aria-selected={tab.id === activeTab}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2 text-sm font-medium transition-colors ${
              tab.id === activeTab
                ? 'border-b-2 border-blue-500 text-blue-600 dark:text-blue-400'
                : 'text-zinc-500 hover:text-zinc-700 dark:text-zinc-400 dark:hover:text-zinc-200'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="pt-3 flex flex-col flex-1 min-h-0">
        {activeIndex >= 0 ? childArray[activeIndex] : null}
      </div>
    </div>
  );
}
